import Common from '../common'
var Js = Common('coupon')
export default {
	name: 'coupon',
	mixins:[Js],
	components: {},
	data() {
		return {
			fields: [{
					key: 'id',
					label: 'ID',
					application: [],
					componentName: 'sls-input',
					listType: '',
					width: 50
				},
				{
					key: 'coupon_no',
					label: '优惠券NO',
					application: [],
					componentName: 'sls-input',
					listType: '',
					width: 50
				},
				{
					key: 'title',
					label: '名称',
					application: ['编辑', '添加'],
					componentName: 'sls-input',
					listType: 'normal',
					header_search: {
						componentName: 'sls-input',
						style: 'width:160px;margin-right:2px;',
						placeholder: '请输入名称',
						clearable: true,
						defaultValue: '',
						optionsName: '',
						changeFunc: function(val, self) {
							if (val) {
								self.searchItem.title = val;
							} else {
								delete self.searchItem.title;
							};
							
						},
					},
				},
				{
					key: 'value',
					label: '抵扣额',
					application: ['编辑', '添加'],
					componentName: 'sls-input',
					listType: 'normal',
				},
				{
					key: 'condition',
					label: '限额（满减）',
					application: ['编辑', '添加'],
					componentName: 'sls-input',
					listType: 'normal',
				},
				{
					key: 'price',
					label: '所需积分',
					application: ['编辑', '添加'],
					componentName: 'sls-input',
					listType: 'normal',
				},
				{
					key: 'stock',
					label: '库存',
					application: ['编辑', '添加'],
					componentName: 'sls-input',
					listType: 'normal',
				},
				// {
				// 	key: 'listorder',
				// 	label: '排序',
				// 	application: ['编辑', '添加'],
				// 	componentName: 'sls-input',
				// 	listType: '',
				// },
				
				// {
				// 	key: 'limit',
				// 	label: '领取数量限制',
				// 	application: ['编辑','添加'],
				// 	componentName: 'sls-input',
				// 	listType: 'normal',
				// },
				
				// {
				// 	key: 'use_limit',
				// 	label: '使用数量限制',
				// 	application: [],
				// 	componentName: 'sls-input',
				// 	listType: '',
				// },
				{
					key: 'time',
					label: '有效期(天)',
					application: ['编辑', '添加'],
					componentName: 'sls-input',
					listType: 'normal',
					formatter:function(val){
						return val.time+'天'
					}
				},
				{
					key: "status",
					label: '状态',
					application: [],
					componentName: 'sls-select',
					optionsName: 'statusOptions',
					defaultProps: {
						label: 'text',
						value: 'value',
					},
					formatter: function(val) {
						if (val.status == 1) {
							return '启用';
						} else {
							return '关闭';
						};
					}
				},
				{
					key: 'create_time',
					label: '创建时间',
					listType: 'normal',
					placeholder: '请选择创建时间',
					header_search: {
						componentName: 'sls-date-time-range',
						style: 'width:160px;margin-right:2px;',
						start_placeholder: '创建开始时间',
						end_placeholder: '创建结束时间',
						changeFunc: function(value, self) {
							if (!value) {
								delete self.searchItem.create_time;
							} else {
								self.searchItem.create_time = ['between', value = value.map(function(e) {
									return e / 1000;
								})]
							};
							
						},
					},
					width: 200,
				},
				{
					label: '操作',
					listType: 'deal',
					width: 200
				},
			],
			// 按钮配置
			btn_info: [


				{
					type: 'info',
					icon: 'edit',
					size: 'mini',
					position: 'list',
					text: function(data) {
						return '编辑'
					},
					func: {
						apiName: function(self) {
							return "api_couponUpdate"
						},
						formData: function(self) {
							return self.formData;
						},
						postData: function(self) {
							if (self.submitData.category_id == 0) {
								return false;
							};
							self.submitData.valid_time = self.submitData.time ? self.submitData.time * 86400 * 1000 : self.formData.valid_time;
							var postData = {
								searchItem: {
									id: self.formData.id,
								},
								data: self.submitData
							};
							return postData;
						}
					},
				},
				{
					type: 'danger',
					icon: 'delete',
					size: 'mini',
					funcType: 'submit',
					position: 'header',
					text: function(data) {
						return '删除选中'
					},
					func: {
						apiName: function(self) {
							return "api_couponUpdate"
						},
						postData: function(self) {
							var deleteArray = [];
							for (var i = 0; i < self.selectionArray.length; i++) {
								deleteArray.push(self.selectionArray[i].id);
							};
							var postData = {
								searchItem: {
									id: ['in', deleteArray],
								},
								data: {
									status: -1
								}
							};
							return postData;
						}
					},
				},
				{
					type: 'info',
					icon: 'edit',
					size: 'mini',
					position: 'header',
					text: function(data) {
						return '添加'
					},
					func: {
						apiName: function(self) {
							return "api_couponAdd"
						},
						formData: function(self) {
							var data = {
								title: '',
								description: '',
								price: '',
								mainImg: [],
								bannerImg: [],
							};
							return data
						},
						postData: function(self) {
							self.submitData.valid_time = self.submitData.time ? self.submitData.time * 86400 * 1000 : '';
							self.submitData.type = 2;
							self.submitData.limit = 0;
							self.submitData.behavior = 0;
							var postData = {
								data: self.submitData
							};
							return postData;
						}
					},
				},
			],


			searchItem: {
				thirdapp_id: this.$store.getters.getUserinfo.thirdapp_id,
				type:2,
				behavior:0
			},
			startSearchItem: {
				thirdapp_id: this.$store.getters.getUserinfo.thirdapp_id,
				type:2,
				behavior:0
			},
			optionData: {
				statusOptions: [{
					text: '启用',
					value: 1
				}, {
					text: '禁用',
					value: -1
				}],
			},
			otherData: {},
			UserInfo: {
				tableName: 'UserInfo',
				searchItem: {},
				key: 'user_no',
				middleKey: 'user_no',
				condition: 'in',
			},

		}

	},

	mounted() {
		const self = this;
		self.table_arguments.tree_props = {
			children: 'child',
			child: 'child',
			hasChildren: 'child'
		}
		self.searchData = self.$$cloneForm(self.searchItem);
		this.init()
	},
	computed: {
		token: function() {
			return this.$store.getters.getToken
		}
	},
	methods: {

		/**
		 * 初始化
		 */
		init() {
			this.initMainData();
		},


		/**
		 * 列表主函数
		 */
		async initMainData(isNew) {

			const self = this;
			self.table_arguments.loading = true;
			const postData = {};
			if (isNew) {
				self.paginate.currentPage = 1;
			};
			postData.paginate = self.$$cloneForm(self.paginate);
			postData.token = self.$store.getters.getToken;
			if (self.searchItem) {
				postData.searchItem = self.$$cloneForm(self.searchItem)
			};
			if (JSON.stringify(self.getBefore) != "{}") {
				postData.getBefore = self.$$cloneForm(self.getBefore);
			};

			var res = await self.$$api_couponGet({
				data: postData
			});
			self.mainData = res.info.data;
			self.paginate.count = res.info.total;
			self.table_arguments.loading = false;

		},

	},


}



// WEBPACK FOOTER //
// ./src/views/product/coupon.js